import { normalizeKey } from './normalize';

// Privacy: only these keys are allowed in the public profile box.
export const PUBLIC_PROFILE_KEYS = [
  'Nome struttura',
  'Indirizzo',
  'Sito web',
  'Telefono',
  'E-mail',
];

// Privacy: never include these keys in PDF output.
export const PRIVATE_FIELD_BLACKLIST = [
  'Referente (da non pubblicare)',
  'Telefono referente',
  'E-mail referente',
  'Email rilevatore',
  'Rilevatore',
];

const normalizedKeys = PUBLIC_PROFILE_KEYS.map((key) => normalizeKey(key));
const normalizedBlacklist = PRIVATE_FIELD_BLACKLIST.map((key) => normalizeKey(key));

export const PUBLIC_PROFILE_KEYS_SET = new Set<string>(normalizedKeys);
export const PRIVATE_FIELD_BLACKLIST_SET = new Set<string>(normalizedBlacklist);

export const isPublicProfileKey = (key: string): boolean =>
  PUBLIC_PROFILE_KEYS_SET.has(normalizeKey(key));

export const isBlacklistedKey = (key: string): boolean =>
  PRIVATE_FIELD_BLACKLIST_SET.has(normalizeKey(key));
